export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/infographics.690345a.svg";